import React from 'react';
import { X, Facebook, Instagram, Youtube, TrendingUp } from 'lucide-react';
import LogoImg from '../assets/white-logo.png';

const MainFooter = ({ onNavigate }) => {
  const trendingSearches = [
    { label: 'Gifts for Mom', query: 'Gifts for Mom' },
    { label: 'Birthday Gifts', query: 'Birthday Gifts' },
    { label: 'Tech Gadgets', query: 'Tech Gadgets for him' },
    { label: 'Home Decor', query: 'Home Decor gifts' },
    { label: 'Personalized Gifts', query: 'Personalized custom gifts' },
    { label: 'Gifts Under $50', query: 'Affordable gifts under 50 dollars' },
    { label: 'Anniversary Gifts', query: 'Anniversary gifts for couples' },
    { label: 'Gifts for Dad', query: 'Gifts for Dad' }
  ];

  const handleQuickSearch = (searchItem) => {
    if (onNavigate) {
      onNavigate('aiFinder', { quickSearch: searchItem.query });
    }
  };

  return (
    <footer className="bg-[#06402B] text-white mt-12 md:mt-16 relative z-20">
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={LogoImg}
                alt="GivAura logo"
                className="h-10 w-auto object-contain"
              />
              <h2 className="text-white text-4xl font-seasons">GivAura</h2>
            </div>
            <p className="text-white/70 text-sm mb-6">
              Thoughtful gifts made effortless with AI-powered recommendations.
            </p>
          </div>
          
          {/* Navigation */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <button 
                  onClick={() => onNavigate?.('home')}
                  className="transition-colors hover:text-white"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate?.('aiFinder')}
                  className="transition-colors hover:text-white"
                >
                  AI Gift Finder
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate?.('wishlist')}
                  className="transition-colors hover:text-white"
                >
                  Wishlist
                </button>
              </li>
              <li>
                <button 
                  onClick={() => onNavigate?.('profile')}
                  className="transition-colors hover:text-white"
                >
                  My Profile
                </button>
              </li>
            </ul>
          </div>
          
          {/* Trending Searches */}
          <div>
            <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
              <TrendingUp className="w-4 h-4" />
              Trending Searches
            </h3>
            <ul className="space-y-2 text-sm text-white/70">
              {trendingSearches.slice(0, 4).map((item, index) => (
                <li key={index}>
                  <button 
                    onClick={() => handleQuickSearch(item)}
                    className="transition-colors hover:text-white text-left"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          {/* More Trending + Social */}
          <div>
            <h3 className="font-bold text-lg mb-4">Popular Categories</h3>
            <ul className="space-y-2 text-sm text-white/70 mb-6">
              {trendingSearches.slice(4).map((item, index) => (
                <li key={index}>
                  <button 
                    onClick={() => handleQuickSearch(item)}
                    className="transition-colors hover:text-white text-left"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
            
            <div className="flex gap-3">
              <a 
                href="https://x.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 border border-white/20 rounded-full flex items-center justify-center hover:bg-[#FBFCF6] hover:text-[#06402B] transition-all"
              >
                <X className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 border border-white/20 rounded-full flex items-center justify-center hover:bg-[#FBFCF6] hover:text-[#06402B] transition-all"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 border border-white/20 rounded-full flex items-center justify-center hover:bg-[#FBFCF6] hover:text-[#06402B] transition-all"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 border border-white/20 rounded-full flex items-center justify-center hover:bg-[#FBFCF6] hover:text-[#06402B] transition-all"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-6 text-center text-sm text-white/60">
          As an Amazon Associate, GiveAura earns from qualifying purchases.
          © Copyright 2026 GivAura. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;